<file-upload
    [control]="fileUploadControl"
    [accept]="'.jpg, .jpeg, .png'"
    [multiple]="'false'">
</file-upload>
